import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import client, { apiCall } from '../../api/client';
import Loader from '../../components/Loader';

const QUICK_LINKS = [
  { to: '/dashboard/api-keys', label: 'Manage API keys', desc: 'Create, rename, or revoke keys' },
  { to: '/dashboard/endpoints', label: 'View RPC endpoints', desc: 'Copy your per-network URLs' },
  { to: '/dashboard/usage', label: 'View usage logs', desc: 'See recent RPC call activity' },
];

export default function Overview() {
  const [plan, setPlan] = useState(null);
  const [planMaster, setPlanMaster] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    apiCall(client.get('/credit_plan/active'))
      .then(async (activePlan) => {
        setPlan(activePlan);
        const plans = await apiCall(client.get('/credit_plan/get_list'));
        setPlanMaster(plans.find((p) => p.uniqueId === activePlan.planId) || null);
      })
      .catch((e) => setError(e.message));
  }, []);

  if (error) {
    return (
      <div>
        <h1>Overview</h1>
        <div className="card">
          <p>{error}</p>
          <Link to="/pricing" className="btn btn-primary">Choose a plan</Link>
        </div>
      </div>
    );
  }

  if (!plan || !planMaster) {
    return (
      <div>
        <h1>Overview</h1>
        <Loader label="Loading your plan..." />
      </div>
    );
  }

  const dailyPct = Math.min(100, (plan.creditsUsedToday / planMaster.dailyCreditCap) * 100);
  const monthlyPct = Math.min(100, (plan.creditsUsedThisMonth / planMaster.monthlyCredits) * 100);

  return (
    <div>
      <h1>Overview</h1>
      <div className="stat-grid">
        <div className="stat-card">
          <div className="stat-label">Current plan</div>
          <div className="stat-value">{planMaster.name}</div>
          <div className="stat-sub">Expires {new Date(plan.expiryDate).toLocaleDateString()}</div>
          {/* <div className="stat-sub">Renews {new Date(plan.expiryDate).toLocaleDateString()}</div> */}
        </div>
        <div className="stat-card">
          <div className="stat-label">Daily credits used</div>
          <div className="stat-value">{plan.creditsUsedToday.toLocaleString()} / {planMaster.dailyCreditCap.toLocaleString()}</div>
          <div className="progress-bar"><div className="progress-bar-fill" style={{ width: `${dailyPct}%` }} /></div>
        </div>
        <div className="stat-card">
          <div className="stat-label">Monthly credits used</div>
          <div className="stat-value">{plan.creditsUsedThisMonth.toLocaleString()} / {planMaster.monthlyCredits.toLocaleString()}</div>
          <div className="progress-bar"><div className="progress-bar-fill" style={{ width: `${monthlyPct}%` }} /></div>
        </div>
        {/* <div className="stat-card">
          <div className="stat-label">Rate limit</div>
          <div className="stat-value">{planMaster.rateLimitPerSecond} rps</div>
          <div className="stat-sub">{planMaster.allowedNetworks.length} networks included</div>
        </div> */}
      </div>
      <div className="card">
        <div className="card-header"><h3>Quick links</h3></div>
        <div className="quick-links">
          {QUICK_LINKS.map(({ to, label, desc }) => (
            <Link key={to} to={to} className="quick-link-row">
              <div>
                <div className="quick-link-label">{label}</div>
                <div className="quick-link-desc">{desc}</div>
              </div>
              <span className="quick-link-arrow">&rarr;</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
